/*global angular*/
module.exports = ['$q', 'settings', 'curriculumManager', '$state', 'ageRangeManager', function ($q, settings, curriculumManager, $state, ageRangeManager) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./referenceWidget.html'),
    replace: true,
    transclude: true,
    scope: {
      referenceGroupInput: '=referenceGroup',
      findFunction: '=',
      referenceState: '@',
      example: '='
    },
    link: function (scope) {
      scope.referenceGroup = _.cloneDeep(scope.referenceGroupInput);
      console.log(scope.referenceGroup);
      scope.state = $state;
      var three = {};
      var lookups = [];
      var onlyFields = true;
      scope.selections = {};

      function addAgeRangeText(item) {
        item.ageRangeText = ageRangeManager.ageRangeToString(item.startage, item.endage);
        return item;
      }

      var findAndAddGoal = function (goal) {
        if (!three[goal.theme.key]) {
          three[goal.theme.key] = {
            items: [],
            root: goal.theme
          };
        }
        if (three && three[goal.theme.key] && _.find(three[goal.theme.key].items, {key: goal.key})) {
          goal = _.find(three[goal.theme.key].items, {key: goal.key});
        } else {
          three[goal.theme.key].items.push(goal);
        }
        return goal;
      };

      scope.referenceGroup.contents.forEach(function (content) {
        var d = $q.defer();
        lookups.push(d.promise);
        //var relation = _.find(content.$$relationsFrom, {$$expanded: {relationtype: 'REFERENCES'}});
        var relations = _.filter(content.$$relationsFrom, function (relationFrom) {
          return relationFrom.$$expanded.relationtype = 'REFERENCES';
        });
      
        relations.forEach(function(relation) {
          var relationTo = relation.$$expanded.to.href.split('/')[relation.$$expanded.to.href.split('/').length - 1];
          console.log('/content/' + relationTo);
          curriculumManager.getByHref('/content/' + relationTo).then(function (item) {
            var foundGoal;
            if (item) {
              if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD') {
                three[item.key] = {
                  items: [],
                  root: item,
                  self: true
                };
              } else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_THEME') {
                three[item.key] = {
                  items: [],
                  root: item,
                  self: true
                };
                onlyFields = false;
              } else if (item.type === 'CURRICULUM_ZILL_GENERIC_GOAL') {
                if (!three[item.theme.key]) {
                  three[item.theme.key] = {
                    items: [],
                    root: item.theme
                  };
                }
                onlyFields = false;
                three[item.theme.key].items.push(item);
                scope.selections[item.theme.field.key] = three[item.theme.key].items.length;
              } else if (item.type === 'CURRICULUM_ZILL_LEERLIJN_CLUSTER') {
                if (item.parentName === 'content2') {
                  foundGoal = findAndAddGoal(_.clone(item.leerlijn.content2.content1.contentGroup.goal));
                  if (!foundGoal.content2LeerlijnRef) {
                    foundGoal.content2LeerlijnRef = [];
                  }
                  foundGoal.content2LeerlijnRef.push(addAgeRangeText(item));
                } else if (item.parentName === 'content1') {
                  foundGoal = findAndAddGoal(_.clone(item.leerlijn.content1.contentGroup.goal));
                  if (!foundGoal.content1LeerlijnRef) {
                    foundGoal.content1LeerlijnRef = [];
                  }
                  foundGoal.content1LeerlijnRef.push(addAgeRangeText(item));
                } else {
                  foundGoal = findAndAddGoal(_.clone(item.leerlijn.goal));
                  if (!foundGoal.leerlijnRef) {
                    foundGoal.leerlijnRef = [];
                  }
                  foundGoal.leerlijnRef.push(addAgeRangeText(item));
                }
                onlyFields = false;
              } else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT') {
                if (item.parentName === 'content1') {
                  foundGoal = findAndAddGoal(_.clone(item.content1.contentGroup.goal));
                  if (!foundGoal.content2Ref) {
                    foundGoal.content2Ref = [];
                  }
                  foundGoal.content2Ref.push(item);
                } else {
                  foundGoal = findAndAddGoal(_.clone(item.contentGroup.goal));
                  if (!foundGoal.content1Ref) {
                    foundGoal.content1Ref = [];
                  }
                  foundGoal.content1Ref.push(item);
                }
                onlyFields = false;
              } else {
                console.warn('/content/' + relationTo);
              }
            } else {
              //content
            }
          });
        });
        
        d.resolve();
      });

      $q.all(lookups).then(function () {
        if (Object.keys(three).length > 0) {
          if (onlyFields) {
            scope.type = 'curriculum_reference_fields';
          } else if (scope.example) {
            scope.type = 'curriculum_reference_example';
          } else {
            scope.type = 'curriculum_reference';
          }
          three = _.sortBy(three, function (o) {
            var readOrder;
            if (o.root.field) {
              readOrder = parseInt(o.root.field.readorder, 0);
            } else {
              readOrder = parseInt(o.root.readorder, 0);
            }
            return readOrder;
          });
          three.forEach(function (items) {
            items.items = _.sortBy(items.items, function (o) {
              return o.readorder;
            });
          });
          scope.three = three;
        } else if (scope.findFunction) {
          scope.referenceGroup.contents.forEach(function (ref) {
            var relation = _.find(ref.$$relationsFrom, {$$expanded: {relationtype: 'REFERENCES'}});
            var key;
            if (relation) {
              key = relation.$$expanded.to.href.split('/')[relation.$$expanded.to.href.split('/').length - 1];
              ref.relation = scope.findFunction(key);
            }
          });
          scope.type = 'text_reference';
        }
      });
    }
  };
}];



// WEBPACK FOOTER //
// ./web/js/module/visionText/js/referenceWidget/referenceWidget.js